/* eslint-disable */
import { TextParagraph } from '@/models/discover/TextParagraph';

import { SERUM_USAGES, PRODUCT_NAMES } from './treatment';
import { ICON, ICON_VALUE } from './icons';

const CLAIM = {
  NO_SILICONS: ICON.NO_SILICONS,
  NO_MIT_MCIT: ICON.NO_MIT_MCIT,
  NO_PHENOXYETHANOL: ICON.NO_PHENOXYETHANOL,
  NO_ENDOCRINE_DISRUPTORS: ICON.NO_ENDOCRINE_DISRUPTORS,
  NO_MINERAL_OILS: ICON.NO_MINERAL_OILS,
  NO_PEG: ICON.NO_PEG,
  NO_SULFATES: ICON.NO_SULFATES,
  NO_GMO: ICON.NO_GMO,
  NO_NANO: ICON.NO_NANO,
  NO_ALCOHOL_DENAT: ICON.NO_ALCOHOL_DENAT,
  CONTAIN_FRAGRANCE: 'CONTAIN_FRAGRANCE',
  NO_FRAGRANCE: 'NO_FRAGRANCE',
  VEGAN: ICON.VEGAN,
  GLUTEN_FREE: ICON.GLUTEN_FREE,
  CRUELTY_FREE: ICON.CRUELTY_FREE,
  CLINICALLY_PROVEN: ICON.CLINICALLY_PROVEN
};

const WARNING_TITLES = [
  'goodToKnow.warning.dryPlace',
  'goodToKnow.warning.keepOutOfChildren',
  'goodToKnow.warning.externalUse'
];

const CLAIM_TITLE = {
  [CLAIM.NO_SILICONS]: 'discover.expandableList.claim.noSilicons',
  [CLAIM.NO_MIT_MCIT]: 'discover.expandableList.claim.noMIT',
  [CLAIM.NO_PHENOXYETHANOL]: 'discover.expandableList.claim.noPhenoxyethanol',
  [CLAIM.NO_ENDOCRINE_DISRUPTORS]: 'discover.expandableList.claim.noEndocrineDisruptors',
  [CLAIM.NO_MINERAL_OILS]: 'discover.expandableList.claim.noMineralOils',
  [CLAIM.NO_MINERAL_OILS_CONTAINS_PALM_OIL]:
    'discover.expandableList.claim.noMineralOils.containsPalmOil',
  [CLAIM.NO_PEG]: 'discover.expandableList.claim.noPEG',
  [CLAIM.NO_SULFATES]: 'discover.expandableList.claim.noSulfates',
  [CLAIM.NO_GMO]: 'discover.expandableList.claim.noGMO',
  [CLAIM.NO_NANO]: 'discover.expandableList.claim.noNano',
  [CLAIM.NO_ALCOHOL_DENAT]: 'discover.expandableList.claim.noAlcoholDenat',
  [CLAIM.CONTAIN_FRAGRANCE]: 'discover.expandableList.claim.containsFragrance',
  [CLAIM.NO_FRAGRANCE]: 'discover.expandableList.claim.noFragrance',
  [CLAIM.VEGAN]: 'discover.expandableList.claim.vegan',
  [CLAIM.GLUTEN_FREE]: 'discover.expandableList.claim.glutenFree',
  [CLAIM.CRUELTY_FREE]: 'discover.expandableList.claim.crueltyFree',
  [CLAIM.CLINICALLY_PROVEN]: 'discover.expandableList.claim.clinicallyProven'
};

const CLAIM_ICON_VALUE = {
  [CLAIM.NO_SILICONS]: ICON_VALUE.NO_SILICONS,
  [CLAIM.NO_MIT_MCIT]: ICON_VALUE.NO_MIT_MCIT,
  [CLAIM.NO_PHENOXYETHANOL]: ICON_VALUE.NO_PHENOXYETHANOL,
  [CLAIM.NO_ENDOCRINE_DISRUPTORS]: ICON_VALUE.NO_ENDOCRINE_DISRUPTORS,
  [CLAIM.NO_MINERAL_OILS]: ICON_VALUE.NO_MINERAL_OILS,
  [CLAIM.NO_MINERAL_OILS_CONTAINS_PALM_OIL]: ICON_VALUE.NO_MINERAL_OILS,
  [CLAIM.NO_PEG]: ICON_VALUE.NO_PEG,
  [CLAIM.NO_SULFATES]: ICON_VALUE.NO_SULFATES,
  [CLAIM.NO_GMO]: ICON_VALUE.NO_GMO,
  [CLAIM.NO_NANO]: ICON_VALUE.NO_NANO,
  [CLAIM.NO_ALCOHOL_DENAT]: ICON_VALUE.NO_ALCOHOL_DENAT,
  [CLAIM.CONTAIN_FRAGRANCE]: ICON_VALUE.FRAGRANCE,
  [CLAIM.NO_FRAGRANCE]: ICON_VALUE.FRAGRANCE,
  [CLAIM.VEGAN]: ICON_VALUE.VEGAN,
  [CLAIM.GLUTEN_FREE]: ICON_VALUE.GLUTEN_FREE,
  [CLAIM.CRUELTY_FREE]: ICON_VALUE.CRUELTY_FREE,
  [CLAIM.CLINICALLY_PROVEN]: ICON_VALUE.CLINICALLY_PROVEN
};

const SERUM_CLAIMS = [
  CLAIM.NO_SILICONS,
  CLAIM.NO_MIT_MCIT,
  CLAIM.NO_PHENOXYETHANOL,
  CLAIM.NO_ENDOCRINE_DISRUPTORS,
  CLAIM.NO_PEG,
  CLAIM.NO_GMO,
  CLAIM.NO_NANO,
  CLAIM.CONTAIN_FRAGRANCE,
  CLAIM.VEGAN,
  CLAIM.GLUTEN_FREE,
  CLAIM.CRUELTY_FREE,
  CLAIM.CLINICALLY_PROVEN
];

const PRODUCT_CLAIMS = {
  [PRODUCT_NAMES.FACE_SERUM]: SERUM_CLAIMS,
  [PRODUCT_NAMES.EYE_CONTOUR_SERUM]: SERUM_CLAIMS,
  [PRODUCT_NAMES.NEXULTRA_O]: [
    CLAIM.NO_SILICONS,
    CLAIM.NO_MIT_MCIT,
    CLAIM.NO_PHENOXYETHANOL,
    CLAIM.NO_ENDOCRINE_DISRUPTORS,
    CLAIM.NO_MINERAL_OILS,
    CLAIM.NO_SULFATES,
    CLAIM.NO_GMO,
    CLAIM.NO_NANO,
    CLAIM.NO_ALCOHOL_DENAT,
    CLAIM.NO_FRAGRANCE,
    CLAIM.VEGAN,
    CLAIM.GLUTEN_FREE,
    CLAIM.CRUELTY_FREE,
    CLAIM.CLINICALLY_PROVEN
  ],
  [PRODUCT_NAMES.NEXULTRA_1]: [
    CLAIM.NO_MIT_MCIT,
    CLAIM.NO_PHENOXYETHANOL,
    CLAIM.NO_MINERAL_OILS,
    CLAIM.NO_GMO,
    CLAIM.NO_NANO,
    CLAIM.NO_ALCOHOL_DENAT,
    CLAIM.NO_FRAGRANCE,
    CLAIM.VEGAN,
    CLAIM.GLUTEN_FREE,
    CLAIM.CRUELTY_FREE,
    CLAIM.CLINICALLY_PROVEN
  ],
  [PRODUCT_NAMES.NEXULTRA_2]: [
    CLAIM.NO_MIT_MCIT,
    CLAIM.NO_ENDOCRINE_DISRUPTORS,
    CLAIM.NO_MINERAL_OILS,
    CLAIM.NO_GMO,
    CLAIM.NO_NANO,
    CLAIM.NO_ALCOHOL_DENAT,
    CLAIM.CONTAIN_FRAGRANCE,
    CLAIM.VEGAN,
    CLAIM.GLUTEN_FREE,
    CLAIM.CRUELTY_FREE,
    CLAIM.CLINICALLY_PROVEN
  ],
  [PRODUCT_NAMES.NEXULTRA_3]: [
    CLAIM.NO_MIT_MCIT,
    CLAIM.NO_PHENOXYETHANOL,
    CLAIM.NO_ENDOCRINE_DISRUPTORS,
    CLAIM.NO_MINERAL_OILS,
    CLAIM.NO_GMO,
    CLAIM.NO_NANO,
    CLAIM.NO_ALCOHOL_DENAT,
    CLAIM.CONTAIN_FRAGRANCE,
    CLAIM.VEGAN,
    CLAIM.GLUTEN_FREE,
    CLAIM.CRUELTY_FREE,
    CLAIM.CLINICALLY_PROVEN
  ],
  [PRODUCT_NAMES.GEL]: [
    CLAIM.NO_SILICONS,
    CLAIM.NO_MINERAL_OILS,
    CLAIM.NO_GMO,
    CLAIM.NO_NANO,
    CLAIM.VEGAN,
    CLAIM.GLUTEN_FREE,
    CLAIM.CRUELTY_FREE
  ],
  [PRODUCT_NAMES.SUNSCREEN_FLD]: [
    CLAIM.NO_MIT_MCIT,
    CLAIM.NO_PHENOXYETHANOL,
    CLAIM.NO_ENDOCRINE_DISRUPTORS,
    CLAIM.NO_MINERAL_OILS,
    CLAIM.NO_GMO,
    CLAIM.NO_NANO,
    CLAIM.NO_ALCOHOL_DENAT,
    CLAIM.NO_FRAGRANCE,
    CLAIM.VEGAN,
    CLAIM.GLUTEN_FREE,
    CLAIM.CRUELTY_FREE
  ],
  [PRODUCT_NAMES.NEXULTRA_B]: [
    CLAIM.NO_SILICONS,
    CLAIM.NO_MIT_MCIT,
    CLAIM.NO_PHENOXYETHANOL,
    CLAIM.NO_ENDOCRINE_DISRUPTORS,
    CLAIM.NO_MINERAL_OILS,
    CLAIM.NO_PEG,
    CLAIM.NO_GMO,
    CLAIM.NO_NANO,
    CLAIM.NO_ALCOHOL_DENAT,
    CLAIM.NO_FRAGRANCE,
    CLAIM.VEGAN,
    CLAIM.GLUTEN_FREE,
    CLAIM.CRUELTY_FREE,
    CLAIM.CLINICALLY_PROVEN
  ],
  [PRODUCT_NAMES.UNIVERSKIN_H]: [
    CLAIM.NO_SILICONS,
    CLAIM.NO_MIT_MCIT,
    CLAIM.NO_PHENOXYETHANOL,
    CLAIM.NO_ENDOCRINE_DISRUPTORS,
    CLAIM.NO_MINERAL_OILS,
    CLAIM.NO_PEG,
    CLAIM.NO_GMO,
    CLAIM.NO_NANO,
    CLAIM.NO_ALCOHOL_DENAT,
    CLAIM.NO_FRAGRANCE,
    CLAIM.VEGAN,
    CLAIM.GLUTEN_FREE,
    CLAIM.CRUELTY_FREE,
    CLAIM.CLINICALLY_PROVEN
  ],
  [PRODUCT_NAMES.NEXULTRA_L]: [
    CLAIM.NO_MIT_MCIT,
    CLAIM.NO_ENDOCRINE_DISRUPTORS,
    CLAIM.NO_MINERAL_OILS,
    CLAIM.NO_GMO,
    CLAIM.NO_ALCOHOL_DENAT,
    CLAIM.CONTAIN_FRAGRANCE,
    CLAIM.GLUTEN_FREE,
    CLAIM.CRUELTY_FREE,
    CLAIM.CLINICALLY_PROVEN
  ],
  [PRODUCT_NAMES.SUNSCREEN_SPF]: [
    CLAIM.NO_SILICONS,
    CLAIM.NO_MIT_MCIT,
    CLAIM.NO_PHENOXYETHANOL,
    CLAIM.NO_ENDOCRINE_DISRUPTORS,
    CLAIM.NO_MINERAL_OILS,
    CLAIM.NO_PEG,
    CLAIM.NO_SULFATES,
    CLAIM.NO_GMO,
    CLAIM.NO_ALCOHOL_DENAT,
    CLAIM.NO_FRAGRANCE,
    CLAIM.VEGAN,
    CLAIM.GLUTEN_FREE,
    CLAIM.CRUELTY_FREE,
    CLAIM.CLINICALLY_PROVEN
  ],
    [PRODUCT_NAMES.SUNSCREEN_CRM]: [
    CLAIM.NO_SILICONS,
    CLAIM.NO_MIT_MCIT,
    CLAIM.NO_PHENOXYETHANOL,
    CLAIM.NO_ENDOCRINE_DISRUPTORS,
    CLAIM.NO_MINERAL_OILS,
    CLAIM.NO_PEG,
    CLAIM.NO_SULFATES,
    CLAIM.NO_GMO,
    CLAIM.NO_ALCOHOL_DENAT,
    CLAIM.NO_FRAGRANCE,
    CLAIM.VEGAN,
    CLAIM.GLUTEN_FREE,
    CLAIM.CRUELTY_FREE,
    CLAIM.CLINICALLY_PROVEN
  ],
  [PRODUCT_NAMES.NEXULTRA_UV]: [
    CLAIM.NO_MIT_MCIT,
    CLAIM.NO_PHENOXYETHANOL,
    CLAIM.NO_ENDOCRINE_DISRUPTORS,
    CLAIM.NO_MINERAL_OILS,
    CLAIM.NO_PEG,
    CLAIM.NO_GMO,
    CLAIM.NO_NANO,
    CLAIM.NO_ALCOHOL_DENAT,
    CLAIM.NO_FRAGRANCE,
    CLAIM.VEGAN,
    CLAIM.GLUTEN_FREE,
    CLAIM.CRUELTY_FREE,
    CLAIM.CLINICALLY_PROVEN
  ],
  [PRODUCT_NAMES.NEXULTRA_P_LIGHT]: [
    CLAIM.NO_MIT_MCIT,
    CLAIM.NO_PHENOXYETHANOL,
    CLAIM.NO_ENDOCRINE_DISRUPTORS,
    CLAIM.NO_MINERAL_OILS,
    CLAIM.NO_SULFATES,
    CLAIM.NO_GMO,
    CLAIM.NO_NANO,
    CLAIM.NO_ALCOHOL_DENAT,
    CLAIM.NO_FRAGRANCE,
    CLAIM.VEGAN,
    CLAIM.GLUTEN_FREE,
    CLAIM.CRUELTY_FREE,
    CLAIM.CLINICALLY_PROVEN
  ],
  [PRODUCT_NAMES.NEXULTRA_P_RICH]: [
    CLAIM.NO_MIT_MCIT,
    CLAIM.NO_PHENOXYETHANOL,
    CLAIM.NO_ENDOCRINE_DISRUPTORS,
    CLAIM.NO_MINERAL_OILS,
    CLAIM.NO_SULFATES,
    CLAIM.NO_GMO,
    CLAIM.NO_NANO,
    CLAIM.NO_ALCOHOL_DENAT,
    CLAIM.NO_FRAGRANCE,
    CLAIM.VEGAN,
    CLAIM.GLUTEN_FREE,
    CLAIM.CRUELTY_FREE,
    CLAIM.CLINICALLY_PROVEN
  ],
  [PRODUCT_NAMES.UNIVERSKIN_M]: [
    CLAIM.NO_SILICONS,
    CLAIM.NO_MIT_MCIT,
    CLAIM.NO_PHENOXYETHANOL,
    CLAIM.NO_ENDOCRINE_DISRUPTORS,
    CLAIM.NO_MINERAL_OILS_CONTAINS_PALM_OIL,
    CLAIM.NO_SULFATES,
    CLAIM.NO_GMO,
    CLAIM.NO_NANO,
    CLAIM.NO_ALCOHOL_DENAT,
    CLAIM.CONTAIN_FRAGRANCE,
    CLAIM.VEGAN,
    CLAIM.GLUTEN_FREE,
    CLAIM.CRUELTY_FREE,
    CLAIM.CLINICALLY_PROVEN
  ]
};

const CLAIM_NOTE = {
  [CLAIM.NO_ENDOCRINE_DISRUPTORS]: 'discover.expandableList.section.goodToKnow.note'
};

const PRODUCT_TIPS_AND_TRICKS = {
  [PRODUCT_NAMES.UNIVERSKIN_H]: [
    new TextParagraph({
      title: 'discover.product.universkinH.expandableList.tipsAndTricks.title.faceMask',
      body: 'discover.product.universkinH.expandableList.tipsAndTricks.body.faceMask'
    }),
    new TextParagraph({
      title: 'discover.product.universkinH.expandableList.tipsAndTricks.title.makeUpFixer',
      body: 'discover.product.universkinH.expandableList.tipsAndTricks.body.makeUpFixer'
    })
  ],
  [PRODUCT_NAMES.NEXULTRA_O]: [
    new TextParagraph({
      body: 'discover.product.nexultraO.expandableList.tipsAndTricks.body.p0'
    }),
    new TextParagraph({
      body: 'discover.product.nexultraO.expandableList.tipsAndTricks.body.p1'
    }),
    new TextParagraph({
      body: 'discover.product.nexultraO.expandableList.tipsAndTricks.body.p2'
    })
  ],
  [PRODUCT_NAMES.GEL]: [
    new TextParagraph({
      body: 'discover.product.gel.expandableList.tipsAndTricks.body.p0'
    }),
    new TextParagraph({
      body: 'discover.product.gel.expandableList.tipsAndTricks.body.p1'
    }),
    new TextParagraph({
      body: 'discover.product.gel.expandableList.tipsAndTricks.body.p2'
    })
  ],
  [PRODUCT_NAMES.SUNSCREEN_FLD]: [
    new TextParagraph({
      body: 'discover.product.sunscreenFluidSpf50.expandableList.tipsAndTricks.body.p0'
    }),
    new TextParagraph({
      body: 'discover.product.sunscreenFluidSpf50.expandableList.tipsAndTricks.body.p1'
    }),
    new TextParagraph({
      body: 'discover.product.sunscreenFluidSpf50.expandableList.tipsAndTricks.body.p2'
    })
  ],
  [PRODUCT_NAMES.NEXULTRA_B]: [
    new TextParagraph({
      body: 'discover.product.nexultraB.expandableList.tipsAndTricks.body.p0'
    }),
    new TextParagraph({
      body: 'discover.product.nexultraB.expandableList.tipsAndTricks.body.p1'
    }),
    new TextParagraph({
      body: 'discover.product.nexultraB.expandableList.tipsAndTricks.body.p2'
    })
  ],
  [PRODUCT_NAMES.NEXULTRA_L]: [
    new TextParagraph({
      body: 'discover.product.nexultraL.expandableList.tipsAndTricks.body.p0'
    }),
    new TextParagraph({
      body: 'discover.product.nexultraL.expandableList.tipsAndTricks.body.p1'
    })
  ],
  [PRODUCT_NAMES.SUNSCREEN_SPF]: [
    new TextParagraph({
      body: 'discover.product.sunscreenSPF.expandableList.tipsAndTricks.body.p0'
    }),
    new TextParagraph({
      body: 'discover.product.sunscreenSPF.expandableList.tipsAndTricks.body.p1'
    })
  ],
  [PRODUCT_NAMES.SUNSCREEN_CRM]: [
    new TextParagraph({
      body: 'discover.product.sunscreenCRM.expandableList.tipsAndTricks.body.p0'
    }),
    new TextParagraph({
      body: 'discover.product.sunscreenCRM.expandableList.tipsAndTricks.body.p1'
    })
  ],
  [PRODUCT_NAMES.NEXULTRA_UV]: new TextParagraph({
    body: 'discover.product.nexultraUV.expandableList.topsAndTricks.body'
  }),
  [PRODUCT_NAMES.NEXULTRA_1]: new TextParagraph({
    body: 'discover.product.nexultra1AndNexultra3.expandableList.tipsAndTricks.body'
  }),
  [PRODUCT_NAMES.NEXULTRA_3]: new TextParagraph({
    body: 'discover.product.nexultra1AndNexultra3.expandableList.tipsAndTricks.body'
  }),
  [PRODUCT_NAMES.NEXULTRA_P_LIGHT]: new TextParagraph({
    body: 'discover.product.nexultraP.expandableList.tipsAndTricks.body'
  }),
  [PRODUCT_NAMES.NEXULTRA_P_RICH]: new TextParagraph({
    body: 'discover.product.nexultraP.expandableList.tipsAndTricks.body'
  })
};

const COMPLEMENTARY_PRODUCT_SUBTITLE_TRANSLATION_KEY = {
  [PRODUCT_NAMES.NEXULTRA_O]: 'discover.product.nexultraO.subtitle',
  [PRODUCT_NAMES.NEXULTRA_1]: 'discover.product.nexultra1.subtitle',
  [PRODUCT_NAMES.NEXULTRA_2]: 'discover.product.nexultra2.subtitle',
  [PRODUCT_NAMES.NEXULTRA_3]: 'discover.product.nexultra3.subtitle',
  [PRODUCT_NAMES.GEL]: 'discover.product.gel.subtitle',
  [PRODUCT_NAMES.SUNSCREEN_FLD]: 'discover.product.sunscreenFluidSpf50.subtitle',
  [PRODUCT_NAMES.NEXULTRA_B]: 'discover.product.nexultraB.subtitle',
  [PRODUCT_NAMES.NEXULTRA_L]: 'discover.product.nexultraL.subtitle',
  [PRODUCT_NAMES.SUNSCREEN_SPF]: 'discover.product.sunscreenSPF.subtitle',
  [PRODUCT_NAMES.SUNSCREEN_CRM]: 'discover.product.sunscreenCRM.subtitle',
  [PRODUCT_NAMES.NEXULTRA_UV]: 'discover.product.nexultraUV.subtitle',
  [PRODUCT_NAMES.UNIVERSKIN_H]: 'discover.product.universkinH.subtitle',
  [PRODUCT_NAMES.UNIVERSKIN_M]: 'discover.product.universkinM.subtitle',
  [PRODUCT_NAMES.NEXULTRA_P_LIGHT]: 'discover.product.nexUltraPLight.subtitle',
  [PRODUCT_NAMES.NEXULTRA_P_RICH]: 'discover.product.nexUltraPRich.subtitle'
};

const COMPLEMENTARY_PRODUCT_INTRO_DESCRIPTION = {
  [PRODUCT_NAMES.NEXULTRA_O]: ['discover.product.nexultraO.description.p0'],
  [PRODUCT_NAMES.NEXULTRA_1]: ['discover.product.nexultra1.description.p0'],
  [PRODUCT_NAMES.NEXULTRA_2]: ['discover.product.nexultra2.description.p0'],
  [PRODUCT_NAMES.NEXULTRA_3]: ['discover.product.nexultra3.description.p0'],
  [PRODUCT_NAMES.GEL]: ['discover.product.gel.description.p0'],
  [PRODUCT_NAMES.SUNSCREEN_FLD]: ['discover.product.sunscreenFluidSpf50.description.p0'],
  [PRODUCT_NAMES.NEXULTRA_B]: ['discover.product.nexultraB.description.p0'],
  [PRODUCT_NAMES.NEXULTRA_L]: ['discover.product.nexultraL.description.p0'],
  [PRODUCT_NAMES.SUNSCREEN_SPF]: ['discover.product.sunscreenSPF.description.p0'],
  [PRODUCT_NAMES.SUNSCREEN_CRM]: ['discover.product.sunscreenCRM.description.p0'],
  [PRODUCT_NAMES.NEXULTRA_UV]: ['discover.product.nexultraUV.description.p0'],
  [PRODUCT_NAMES.UNIVERSKIN_H]: ['discover.product.universkinH.description.p0'],
  [PRODUCT_NAMES.UNIVERSKIN_M]: ['discover.product.universkinM.description.p0'],
  [PRODUCT_NAMES.NEXULTRA_P_LIGHT]: ['discover.product.nexultraPLight.description.p0'],
  [PRODUCT_NAMES.NEXULTRA_P_RICH]: ['discover.product.nexultraPRich.description.p0']
};

const COMPLEMENTARY_PRODUCT_USAGE = {
  [PRODUCT_NAMES.NEXULTRA_O]: 'discover.usage.amAndPm',
  [PRODUCT_NAMES.UNIVERSKIN_H]: 'discover.usage.amAndPm',
  [PRODUCT_NAMES.UNIVERSKIN_M]: 'discover.usage.amAndPm',
  [PRODUCT_NAMES.NEXULTRA_1]: {
    [SERUM_USAGES.MORNING_ONLY]: 'discover.usage.am',
    [SERUM_USAGES.EVENING_ONLY]: 'discover.usage.pm',
    [SERUM_USAGES.MORNING_AND_EVENING]: 'discover.usage.amAndPm'
  },
  [PRODUCT_NAMES.NEXULTRA_2]: {
    [SERUM_USAGES.MORNING_ONLY]: 'discover.usage.am',
    [SERUM_USAGES.EVENING_ONLY]: 'discover.usage.pm',
    [SERUM_USAGES.MORNING_AND_EVENING]: 'discover.usage.amAndPm'
  },
  [PRODUCT_NAMES.NEXULTRA_3]: {
    [SERUM_USAGES.MORNING_ONLY]: 'discover.usage.am',
    [SERUM_USAGES.EVENING_ONLY]: 'discover.usage.pm',
    [SERUM_USAGES.MORNING_AND_EVENING]: 'discover.usage.amAndPm'
  },
  [PRODUCT_NAMES.NEXULTRA_L]: 'discover.usage.am',
  [PRODUCT_NAMES.NEXULTRA_B]: '',
  [PRODUCT_NAMES.GEL]: 'discover.usage.amAndPm',
  [PRODUCT_NAMES.SUNSCREEN_FLD]: 'discover.usage.every2hour',
  [PRODUCT_NAMES.SUNSCREEN_SPF]: 'discover.usage.every2hour',
   [PRODUCT_NAMES.SUNSCREEN_CRM]: 'discover.usage.every2hour',
  [PRODUCT_NAMES.NEXULTRA_UV]: 'discover.usage.every2hour',
  [PRODUCT_NAMES.NEXULTRA_P_LIGHT]: {
    [SERUM_USAGES.MORNING_ONLY]: 'discover.usage.am',
    [SERUM_USAGES.EVENING_ONLY]: 'discover.usage.pm',
    [SERUM_USAGES.MORNING_AND_EVENING]: 'discover.usage.amAndPm'
  },
  [PRODUCT_NAMES.NEXULTRA_P_RICH]: {
    [SERUM_USAGES.MORNING_ONLY]: 'discover.usage.am',
    [SERUM_USAGES.EVENING_ONLY]: 'discover.usage.pm',
    [SERUM_USAGES.MORNING_AND_EVENING]: 'discover.usage.amAndPm'
  }
};

export {
  PRODUCT_CLAIMS,
  CLAIM_TITLE,
  CLAIM_ICON_VALUE,
  CLAIM_NOTE,
  PRODUCT_TIPS_AND_TRICKS,
  COMPLEMENTARY_PRODUCT_SUBTITLE_TRANSLATION_KEY,
  COMPLEMENTARY_PRODUCT_USAGE,
  COMPLEMENTARY_PRODUCT_INTRO_DESCRIPTION,
  WARNING_TITLES
};
